module.exports = __webpack_public_path__ + "static/img/hours.fd91eb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hours.png
// module id = phfF
// module chunks = 1